/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { showNotification } from '@mantine/notifications';
import { ScrollArea, useMantineColorScheme } from '@mantine/core';
// import LineCharts from '../../pages/Listing/companyData/LineChart';
import { TableAlias } from 'tabler-icons-react';
import styles from './styles.module.css';
import BarCharts from '../../pages/Listing/companyData/BarChart';
import { assetPrefix, renderNumber } from '../../utilities/general';
import useSorting from '../CommonFunction/useSorting';
import AreaChartsV2 from '../../pages/Listing/companyData/AreaChartV2';
import { tradersColdWalletApi } from '../../utilities/apis/traders';
import { apiWrapWithErrorWithData } from '../../utilities/apis/apiHelpers';
import CommonTable from './CommonTable';
// import { renderNumber } from '../../utilities/general';

const TraderExpandList = ({ data }) => {
  // eslint-disable-next-line no-unused-vars
  const {
    winRateOneMonthsData, winRateOneMonth, walletData, pnlOneMonthData, stakingData, accountId,
  } = data;
  const sortedWalletData = useSorting(walletData, 'totalValueUsd');
  const filterStakingData = stakingData?.filter((val) => val?.quantity !== 0);
  const sortedStakingData = useSorting(filterStakingData, 'totalValueUsd');
  const { colorScheme } = useMantineColorScheme();
  const [coldWalletData, setColdWalletData] = useState(null);
  const filterColdWalletData = coldWalletData?.filter((val) => val?.quantity !== 0);
  const sortedColdWalletData = useSorting(filterColdWalletData, 'totalValueUsd');

  const allOptions = ['Wallet', 'Cold Wallet', 'Staking'];

  const [firstValue, setFirstValue] = useState('Wallet');
  const [secondValue, setSecondValue] = useState('Cold Wallet');

  const dataOptions = {
    Wallet: sortedWalletData,
    'Cold Wallet': sortedColdWalletData,
    Staking: sortedStakingData,
  };

  const firstDropdownOptions = allOptions.filter((opt) => opt !== secondValue);
  const secondDropdownOptions = allOptions.filter((opt) => opt !== firstValue);

  const handleFirstChange = (value) => {
    setFirstValue(value);
    if (value === secondValue) {
      const availableOptions = allOptions.filter((opt) => opt !== value);
      setSecondValue(availableOptions[0]);
    }
  };

  const handleSecondChange = (value) => {
    setSecondValue(value);
    if (value === firstValue) {
      const availableOptions = allOptions.filter((opt) => opt !== value);
      setFirstValue(availableOptions[0]);
    }
  };

  const fetchColdWalletsData = async () => {
    const resp = await apiWrapWithErrorWithData(tradersColdWalletApi(accountId));
    if (resp?.success && resp?.data) {
      const updatedData = resp?.data.map((item) => ({
        ...item,
        asset: item.token.toUpperCase(),
      }));
      setColdWalletData(updatedData);
    } else {
      showNotification({
        color: 'red',
        message: `Couldn't load cold wallet for trader ${accountId}`,
        title: 'Error while fetching cold wallet',
      });
    }
  };

  useEffect(() => {
    fetchColdWalletsData();
  }, []);

  return (
    <>
      <div className={`${colorScheme === 'dark' ? styles.darkContainer : styles.container} flex items-center p-6 gap-5 w-full`}>
        <div className={styles.chartContainer}>
          {/* <LineCharts
            data={pnlOneMonthData}
            chartName="Profit / Loss"
            summury={pnlOneMonth.total}
            changeInPercentage={pnlOneMonth?.changeInPercentage}
            days="30 Days"
            loading="FINISHED"
            chartId="pnlOneMonth"
          /> */}
          <AreaChartsV2
            data={pnlOneMonthData}
            chartName="Profit / Loss"
            days="30 Days"
            loading="FINISHED"
            chartId="pnlOneMonth"
          />
        </div>
        <div className={`${styles.chartContainer} !pt-0 hidden`}>
          <BarCharts
            data={winRateOneMonthsData}
            chartName="Win Rate "
            summury={winRateOneMonth.average}
            days="Last 30 Days"
            color={['#0093EF', '#E9EDF7']}
            loading="FINISHED"
            Listing
          />
        </div>
        <CommonTable
          title={firstValue}
          data={dataOptions[firstValue]}
          dropdownProps={{
            value: firstValue,
            options: firstDropdownOptions,
            onChange: handleFirstChange,
          }}
        />
        <CommonTable
          title={secondValue}
          data={dataOptions[secondValue]}
          dropdownProps={{
            value: secondValue,
            options: secondDropdownOptions,
            onChange: handleSecondChange,
          }}
        />
        {/* <div className={`${styles.hotColdWallet} px-2.5 py-4`}>
          <div className={`${styles.HeadingText}`}>Wallet</div>
          <div className={`${styles.HotColdListingHeader} pt-2.5`}>
            <div className={`grid items-start transition-transform cursor-pointer text-right pb-2 ${styles.HotColdHeadingGrid} ${styles.HotColdHeading}`}>
              <div className="text-left">Asset</div>
              <div>Quantity</div>
              <div>Value</div>
            </div>
          </div>
          {items?.length === 0 ? (
            <div className="h-[74%] flex items-center justify-center gap-3">
              <TableAlias size={22} strokeWidth={1.5} color="#A3AED0" />
              <span className="text-sm font-normal text-center">No Data Found</span>
            </div>
          ) : (
            <ScrollArea style={{ height: '74%' }} type="never" scrollbarSize={5} scrollHideDelay={200}>
              <div className={`${styles.rowContainerMain}`}>
                {!!items?.length && items?.map((asset, index) => (
                  <div className={`${styles.rowContainer} ${index !== walletData?.length - 1 ? 'border-b border-[#CECECE] pb-3' : ''}`}>
                    <div className={`grid items-start transition-transform text-right ${styles.HotColdrowGrid} ${styles.rowText}`}>
                      <div className="flex gap-1">
                        <div>
                          <img
                            src={asset?.icon ? asset?.icon : `${assetPrefix}/images/coinBase.svg`}
                            alt="CoinBase"
                            className="max-w-fit w-4 h-4 rounded-full"
                          />
                        </div>
                        <div>
                          {asset.asset}
                        </div>
                      </div>
                      <div className="!font-normal">{renderNumber(asset?.quantity)}</div>
                      <div className="!font-normal">{renderNumber(asset.totalValueUsd, true)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollArea>
          )}
        </div>

        <div className={`${styles.hotColdWallet} px-2.5 py-4`}>
          <div className={`${styles.HeadingText}`}>Staking</div>
          <div className={`${styles.HotColdListingHeader} pt-2.5`}>
            <div className={`grid items-start transition-transform cursor-pointer text-right pb-2 ${styles.HotColdHeadingGrid} ${styles.HotColdHeading}`}>
              <div className="text-left">Asset</div>
              <div>Quantity</div>
              <div>Value</div>
            </div>
          </div>
          {sortedStakingData?.items?.length === 0 ? (
            <div className="h-[74%] flex items-center justify-center gap-3">
              <TableAlias size={22} strokeWidth={1.5} color="#A3AED0" />
              <span className="text-sm font-normal text-center">No Assets Staked</span>
            </div>
          ) : (
            <ScrollArea style={{ height: '74%' }} type="never" scrollbarSize={5} scrollHideDelay={200}>
              <div className={`${styles.rowContainerMain}`}>
                {!!sortedStakingData?.items?.length && sortedStakingData?.items?.map((asset, index) => (
                  <div className={`${styles.rowContainer} ${index !== filterStakingData?.length - 1 ? 'border-b border-[#CECECE] pb-3' : ''}`}>
                    <div className={`grid items-start transition-transform text-right ${styles.HotColdrowGrid} ${styles.rowText}`}>
                      <div className="flex gap-1">
                        <div>
                          <img
                            src={asset?.icon ? asset?.icon : `${assetPrefix}/images/coinBase.svg`}
                            alt="CoinBase"
                            className="max-w-fit w-4 h-4 rounded-full"
                          />
                        </div>
                        <div>
                          {asset.asset}
                        </div>
                      </div>
                      <div className="!font-normal">{renderNumber(asset?.quantity)}</div>
                      <div className="!font-normal">{renderNumber(asset.totalValueUsd, true)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollArea>
          )}
        </div>

        <div className={`${styles.hotColdWallet} px-2.5 py-4`}>
          <div className={`${styles.HeadingText}`}>Cold Wallet</div>
          <div className={`${styles.HotColdListingHeader} pt-2.5`}>
            <div className={`grid items-start transition-transform cursor-pointer text-right pb-2 ${styles.HotColdHeadingGrid} ${styles.HotColdHeading}`}>
              <div className="text-left">Asset</div>
              <div>Quantity</div>
              <div>Value</div>
            </div>
          </div>
          {sortedColdWalletData?.items?.length === 0 ? (
            <div className="h-[74%] flex items-center justify-center gap-3">
              <TableAlias size={22} strokeWidth={1.5} color="#A3AED0" />
              <span className="text-sm font-normal text-center">No Data Found</span>
            </div>
          ) : (
            <ScrollArea style={{ height: '74%' }} type="never" scrollbarSize={5} scrollHideDelay={200}>
              <div className={`${styles.rowContainerMain}`}>
                {!!sortedColdWalletData?.items?.length && sortedColdWalletData?.items?.map((asset, index) => (
                  <div className={`${styles.rowContainer} ${index !== filterColdWalletData?.length - 1 ? 'border-b border-[#CECECE] pb-3' : ''}`}>
                    <div className={`grid items-start transition-transform text-right ${styles.HotColdrowGrid} ${styles.rowText}`}>
                      <div className="flex gap-1">
                        <div>
                          <img
                            src={asset?.icon ? asset?.icon : `${assetPrefix}/images/coinBase.svg`}
                            alt="CoinBase"
                            className="max-w-fit w-4 h-4 rounded-full"
                          />
                        </div>
                        <div>
                          {asset.asset}
                        </div>
                      </div>
                      <div className="!font-normal">{renderNumber(asset?.quantity)}</div>
                      <div className="!font-normal">{renderNumber(asset.totalValueUsd, true)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollArea>
          )}
        </div> */}

        {/* {data.length !== 0
          ? (
            <div className="w-full relative">
              <div>
                <div className="flex items-center justify-end text-[#3A3A3A] text-lg mt-8 ml-auto mr-[7%]">
                  <div className="text-sm font-normal text-[#898989] mx-5 py-1 px-1 bg-[#FFFFFF] text-center w-[5rem] rounded-md"><span>Last 7 Days</span></div>
                  <div className={`${styles.traderRowGrid} flex grid w-[70.2%]`}>

                    <div>
                      {renderNumber(data.weeklyData.equity, true)}
                    </div>
                    <div>
                      {`${renderNumber(data.weeklyData.returnRate)}%`}
                    </div>
                    <div>
                      {`${renderNumber(data.weeklyData.winRate)}%`}
                    </div>
                    <div>
                      {renderNumber(data.weeklyData.totalPortfolio, true)}
                    </div>
                    <div className={`${data.weeklyData.pNl > 0 ? 'text-green-500' : 'text-red-500'}`}>
                      {renderNumber(data.weeklyData.pNl, true)}
                    </div>
                    <div>
                      {renderNumber(data.weeklyData.commission, true)}
                    </div>

                  </div>
                </div>
                <div className="flex items-center justify-end text-[#3A3A3A] text-lg pt-6 pb-8 ml-auto mr-[7%]">
                  <div className="text-sm font-normal text-[#898989] mx-5 bg-[#FFFFFF] text-center w-[5rem] py-1 px-1 rounded-md"><span>1 Month</span></div>
                  <div className={`${styles.traderRowGrid} flex grid w-[70.2%]`}>
                    <div>
                      {renderNumber(data.monthlyData.equity, true)}
                    </div>
                    <div>
                      {`${renderNumber(data.monthlyData.returnRate)}%`}
                    </div>
                    <div>
                      {`${renderNumber(data.monthlyData.winRate)}%`}
                    </div>
                    <div>
                      {renderNumber(data.monthlyData.totalPortfolio, true)}
                    </div>
                    <div className={`${data.monthlyData.pNl > 0 ? 'text-green-500' : 'text-red-500'}`}>
                      {renderNumber(data.monthlyData.pNl, true)}
                    </div>
                    <div>
                      {renderNumber(data.monthlyData.commission, true)}
                    </div>
                  </div>

                </div>
              </div>
              <div />

            </div>
          )
          : <p className="text-center font-bold">No Data</p>} */}
      </div>
    </>
  );
};

export default TraderExpandList;
